<template>
  <div class="modal fade" ref="vuemodal" id="productsConstructModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('inventory.product_assembly')}}</h5>
          <button type="button" class="close" @click="close">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="form-inline">
              <v-select class="v-select-absolute mr-3" :options="warehouses" label="name" value="id" v-model="warehouse" :clearable="false"></v-select>
              <v-select class="v-select-absolute" :options="products" label="name" value="id" v-model="product" :clearable="false" :disabled="!warehouse.id" v-on:input="onProductInput(product)">
                <span slot="no-options" class="px-3">
                    {{translations('inventory.message_notification_stock_not_found')}}
                  </span>
              </v-select>
              <div class="form-group ml-3 d-flex align-items-center">
                <span class="text-nowrap mr-1">{{translations('inventory.assembly_day')}}</span>
                <input v-model="setting_at" type="date" class="form-control">
              </div>
              <div class="form-group ml-3 d-flex align-items-center">
                <span class="text-nowrap mr-1">{{translations('inventory.remarks')}}</span>
                <input v-model="comment" type="text" class="form-control">
              </div>
            </div>
          </div>
          <div class="table-scroll">
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>{{translations('inventory.jan_code')}}</th>
                  <th>{{translations('inventory.model')}}</th>
                  <th>{{translations('inventory.required_number')}}</th>
                  <th>{{translations('inventory.required_quantity_and_quantity_received')}}</th>
                  <th>{{translations('inventory.quantity_stock')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(part, i) in parts">
                  <tr :key="i">
                    <td>{{ part.ean_code }}</td>
                    <td>{{ part.model }}</td>
                    <td class="right">{{ Number(part.need_quantity).toLocaleString() }}</td>
                    <td class="right" :style="{color: part.need_quantity * quantity > part.stock_quantity ? 'red' : ''}">{{ Number(part.need_quantity * quantity).toLocaleString() }}</td>
                    <td class="right">{{ Number(part.stock_quantity).toLocaleString() }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <label>{{translations('inventory.quantity_received')}}</label>
          <input v-model="quantity" type="text" @input="numbers('quantity')" class="form-control number-container" style="width:80px;" min="0">
          <label>{{translations('inventory.receipt_cost')}}</label>
          <input v-model="original_price_jpy" type="text" @input="numbers('original_price_jpy')" class="form-control number-container" style="width:100px;" min="0">
          <label>{{translations('inventory.amount_received')}}</label>
          <input v-model="totalPrice" type="text" class="form-control number-container" style="width:100px;" min="0" disabled>
          <button type="button" class="btn btn-primary" :disabled="!canExec" @click="constructProduct">{{translations('inventory.assembly')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'

export default {
  name: 'ProductsConstructModal',
  data () {
    return {
      products: [],
      parts: [],
      // warehouse_id: 0,
      // warehouse_name: '',
      // product_id: 0,
      // product_name: '',
      warehouses: [],
      warehouse: null,
      product: null,
      quantity: 1,
      original_price_jpy: 0,
      original_price_jpy_set: 0,
      setting_at: null,
      comment: null
    }
  },
  watch: {
    warehouse: {
      handler: function (val, oldVal) {
        if (!val.id) return
        if (!this.product.product_id) return
        if (!this.setting_at) return
        this.getParts(val.id, this.product.product_id, this.setting_at)
      },
      deep: true
    },
    product: {
      handler: function (val, oldVal) {
        if (!val.product_id) return
        if (!this.warehouse.id) return
        if (!this.setting_at) return
        this.getParts(this.warehouse.id, val.product_id, this.setting_at)
      },
      deep: true
    },
    setting_at: function (newDate) {
      if (!newDate) return
      if (!this.product.product_id) return
      if (!this.warehouse.id) return
      this.getParts(this.warehouse.id, this.product.product_id, newDate)
    }
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', { self: this }, function (e) {
      const self = e.data.self
      e.data.self.warehouses = JSON.parse(JSON.stringify(e.data.self.$store.getters['Master/getMywarehouses']))
      e.data.self.warehouse = {
        id: '',
        name: self.translations('inventory.warehouse_selection')
      }
      e.data.self.product = {
        id: '',
        name: self.translations('inventory.assembly_product_selection')
      }
      e.data.self.products.forEach(product => {
        product.name = product.ean_code + ' ' + product.model + ' ' + product.legacy_code
      })
    })
  },
  created: function () {
    this.setting_at = this.$invoiceTools.getCurrentDate()

    const self = this
    this.$http.get(this.$api_url.products_sets).then(function (response) {
      if (response && response.data.success) {
        self.products = JSON.parse(JSON.stringify(response.data.data))
      } else {
        self.products = []
      }
      self.products.forEach(product => {
        product.name = product.ean_code + ' ' + product.model + ' ' + product.legacy_code
      })
    })
    this.warehouse = {
      id: '',
      name: self.translations('inventory.warehouse_selection')
    }
    this.product = {
      id: '',
      name: self.translations('inventory.assembly_product_selection')
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    canExec: function () {
      const self = this
      return this.quantity > 0 && this.parts.findIndex(function (part, index, arr) {
        return part.need_quantity * self.quantity > part.stock_quantity
      }) < 0
    },
    totalPrice: function () {
      return Number(this.quantity * this.original_price_jpy).toLocaleString()
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    numbers (target) {
      this[target] = this[target].toString().replace(/[^0-9.]/g, '')
    },
    getParts: function (warehouseId, productId, referenceAt) {
      const params = {
        warehouse_id: warehouseId,
        setting_at: referenceAt
      }
      // 構成品一覧取得（id, jan, 型番, 必要個数, 在庫数）
      const self = this
      this.$http.get(this.$api_url.products_sets + '/' + productId, { params }).then(function (response) {
        self.original_price_jpy = 0
        if (response.data && response.data.success) {
          self.parts = JSON.parse(JSON.stringify(response.data.data))
          for (let i = 0; i < self.parts.length; i++) {
            self.original_price_jpy += (Number(self.parts[i].original_price_jpy) * Number(self.parts[i].need_quantity))
          }
          // self.original_price_jpy = self.original_price_jpy_set || self.original_price_jpy // セット品原価を優先
        } else {
          self.parts = []
        }
      })
    },
    constructProduct: function () {
      // 組み立て処理
      const params = {
        warehouse_id: this.warehouse.id,
        quantity: this.quantity,
        parts: this.parts,
        original_price_jpy: this.original_price_jpy,
        setting_at: this.setting_at,
        comment: this.comment
      }
      const self = this
      this.$http.post(this.$api_url.products_sets + '/' + this.product.product_id, params).then(function (response) {
        self.original_price_jpy = 0 // CLEAR
        if (response && response.data.status) {
          self.$toastr.success('組み立て処理が完了しました', '')
          self.close(true)
        } else {
          self.$toastr.error('組み立て処理に失敗しました', 'エラー')
        }
      })
    },
    openProducts: function () {
      if ($('#dropdown-menu').height() > (window.innerHeight - 100)) { // 100マイナスした上で比較
        $('#dropdown-menu').height(window.innerHeight * 0.8 + 'px')
      }
      $('.dropdown-toggle').dropdown()
    },
    close: function (isLoading = false) {
      this.parts = []
      this.warehouse = null
      this.product = null
      this.quantity = 1
      this.warehouses = []
      this.$emit('reload-page', isLoading === true)
      window.$('#productsConstructModal').modal('hide')
    },
    onProductInput: function (product) {
      this.original_price_jpy_set = product.original_price_jpy
      // this.product_id = product.product_id
      // this.product_name = product.ean_code + ' ' + product.model
    }
  }
}
</script>

<style scoped>
.dropdown-menu{
  overflow-y: auto;
}
</style>
